<template>
  <div class="main">
    <h2 class="mb-5">年末年始営業内容のお知らせ</h2>
    <a href="https://www.logi-co.co.jp/pdf/20191213_nen.pdf" target="#">
      年末年始営業内容のお知らせ
    </a>
  </div>
</template>
<script>
import Mixin from '@/components/mixin/Mixin'
export default {
  name: 'Maintenance',
  mixins: [Mixin],
  created: function () {
    this.setScreen({ isLogoOnly: true })
  },
}
</script>
<style lang="sass" scoped>
@import '../assets/css/logico2'
.main
  height: 400px
  text-align: center
  padding-top: 160px
</style>



// WEBPACK FOOTER //
// src/components/Maintenance.vue